var arrayLikeToArray = require("./arrayLikeToArray");

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/~/css-vendor/~/@babel/runtime/helpers/arrayWithoutHoles.js
// module id = 955
// module chunks = 0